import Link from 'next/link';
import { useContext, useState, useEffect } from 'react';
import { WWContext, type WWContextValue } from '../../WWContext';
import { isEditInPreview } from '../../../lib/isEditInPreview';
import { css } from '@emotion/css';
import { Wws_WeddingWebsiteV2 } from '../../../types/graphql';

const PublishBanner = () => {
  const { data } = useContext<WWContextValue>(WWContext);
  const showPublishBanner = !!(
    data?.weddingWebsiteResult as Wws_WeddingWebsiteV2
  )?.showPublishBanner;

  const [shouldRender, setShouldRender] = useState<boolean>(false);
  const text1 = `You're viewing your own website. This is not visible to guests.`;
  const text2 = `Publish your website`;
  const text3 = `when you're ready to show it off.`;

  useEffect(() => {
    const isPreviewFromParams = isEditInPreview();
    setShouldRender(!isPreviewFromParams);
  }, []);

  return shouldRender && showPublishBanner ? (
    <section
      className={css`
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #fff5ed;
        padding: 13px;
        font-size: 16px;
        line-height: 26px;

        @media (max-width: 767.98px) {
          margin-top: 55px;
        }
      `}
    >
      <div>{text1}</div>
      <div>
        <Link
          target="_blank"
          className={css`
            text-decoration: underline;
          `}
          href={process.env['CV_DASHBOARD_URL']!}
        >
          {text2}
        </Link>{' '}
        {text3}
      </div>
    </section>
  ) : null;
};

export default PublishBanner;
